<!-- Header -->
<header class="header-area p-relative">

    <!-- Top Header -->
    <div class="top-header top-header-style-four">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <ul class="top-header-contact-info">
                        <!-- <li>
                            Call:
                            <a>+91 9999999999</a>
                        </li> -->
                    </ul>
                    <!-- <div class="top-header-social">
                        <span>Follow us:</span>
                        <a href="#" target="_blank"><i class='bx bxl-facebook'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-twitter'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a>
                        <a href="#" target="_blank"><i class='bx bxl-instagram'></i></a>
                    </div> -->
                </div>
                <div class="col-lg-4 col-md-4">
                    <!-- <ul class="top-header-login-register">
                        <li><a routerLink="/login"><i class='bx bx-log-in'></i> Login</a></li>
                        <li><a routerLink="/register"><i class='bx bx-log-in-circle'></i> Register</a></li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>

    <!-- Navbar -->
    <div class="navbar-area navbar-style-three" [ngClass]="{'sticky': isSticky}"
        [class.dark-navbar-area]="themeService.isDark()">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
                <a class="navbar-brand" routerLink="/" [class.d-none]="themeService.isDark()">
                    <img src="assets/img/mepma/logo.svg" alt="logo" style="height:65px;">
                </a>
                <a class="navbar-brand d-none" routerLink="/" [class.d-block]="themeService.isDark()">
                    <img src="assets/img/mepma/logo.svg" alt="logo" style="height:65px;">
                </a>

                <span class="navbar-toggler">
                    <li class="nav-item">
                        <a routerLink="/" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">
                            <span class="titlealret">
                                Last Date For Applying: <span class="subhead"> 07-10-2025</span>
                            </span>
                        </a>
                    </li>
                </span>
                <button class="navbar-toggler" type="button" (click)="toggleClass()">
                    <span class="burger-menu">
                        <span class="top-bar"></span>
                        <span class="middle-bar"></span>
                        <span class="bottom-bar"></span>
                    </span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <!-- <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">
                                <span class="titlealret">
                                    Last Date For Applying: <span class="subhead blinking"> {{'07-10-2025'}}</span>
                                </span> </a>
                        </li> -->

                        <li class="nav-item" *ngIf="userData==null">
                            <a class="nav-link" routerLinkActive="active" routerLink="/registration">
                                <span class="titlealret">
                                    New Registration
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" *ngIf="userData==null">
                            <a class="nav-link" routerLinkActive="active" (click)="openPopupview(popupname,1,0)">
                                <span class="titlealret">
                                    Login
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" *ngIf="userData!=null">
                            <a class="nav-link" routerLinkActive="active" (click)="navigteApplyForm()">
                                <span class="titlealret">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        width="24px">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                        </g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path opacity="0.4"
                                                d="M12.1207 12.78C12.0507 12.77 11.9607 12.77 11.8807 12.78C10.1207 12.72 8.7207 11.28 8.7207 9.50998C8.7207 7.69998 10.1807 6.22998 12.0007 6.22998C13.8107 6.22998 15.2807 7.69998 15.2807 9.50998C15.2707 11.28 13.8807 12.72 12.1207 12.78Z"
                                                stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                            <path opacity="0.34"
                                                d="M18.7398 19.3801C16.9598 21.0101 14.5998 22.0001 11.9998 22.0001C9.39977 22.0001 7.03977 21.0101 5.25977 19.3801C5.35977 18.4401 5.95977 17.5201 7.02977 16.8001C9.76977 14.9801 14.2498 14.9801 16.9698 16.8001C18.0398 17.5201 18.6398 18.4401 18.7398 19.3801Z"
                                                stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                            <path
                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </g>
                                    </svg> Profile
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" *ngIf="userData!=null">
                            <a class="nav-link" routerLinkActive="active" (click)="logout()">
                                <span class="titlealret">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        width="24px">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                        </g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M13 2C10.2386 2 8 4.23858 8 7C8 7.55228 8.44772 8 9 8C9.55228 8 10 7.55228 10 7C10 5.34315 11.3431 4 13 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 19.7614 10.2386 22 13 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H13Z"
                                                fill="#fff"></path>
                                            <path
                                                d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11.2821C11.1931 13.1098 11.1078 13.2163 11.0271 13.318C10.7816 13.6277 10.5738 13.8996 10.427 14.0945C10.3536 14.1921 10.2952 14.2705 10.255 14.3251L10.2084 14.3884L10.1959 14.4055L10.1915 14.4115C10.1914 14.4116 10.191 14.4122 11 15L10.1915 14.4115C9.86687 14.8583 9.96541 15.4844 10.4122 15.809C10.859 16.1336 11.4843 16.0346 11.809 15.5879L11.8118 15.584L11.822 15.57L11.8638 15.5132C11.9007 15.4632 11.9553 15.3897 12.0247 15.2975C12.1637 15.113 12.3612 14.8546 12.5942 14.5606C13.0655 13.9663 13.6623 13.2519 14.2071 12.7071L14.9142 12L14.2071 11.2929C13.6623 10.7481 13.0655 10.0337 12.5942 9.43937C12.3612 9.14542 12.1637 8.88702 12.0247 8.7025C11.9553 8.61033 11.9007 8.53682 11.8638 8.48679L11.822 8.43002L11.8118 8.41602L11.8095 8.41281C11.4848 7.96606 10.859 7.86637 10.4122 8.19098C9.96541 8.51561 9.86636 9.14098 10.191 9.58778L11 9C10.191 9.58778 10.1909 9.58773 10.191 9.58778L10.1925 9.58985L10.1959 9.59454L10.2084 9.61162L10.255 9.67492C10.2952 9.72946 10.3536 9.80795 10.427 9.90549C10.5738 10.1004 10.7816 10.3723 11.0271 10.682C11.1078 10.7837 11.1931 10.8902 11.2821 11H3Z"
                                                fill="#fff"></path>
                                        </g>
                                    </svg> Logout
                                </span>
                            </a>
                        </li>
                        <!-- <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Contact</a>
                            </li> -->
                    </ul>
                </div>

            </nav>
        </div>
    </div>

</header>

<!-- Search Overlay -->
<div class="search-overlay" [class.active]="classApplied3" [class.dark-search-overlay]="themeService.isDark()">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-close" (click)="toggleClass3()">
                <span class="search-overlay-close-line"></span>
                <span class="search-overlay-close-line"></span>
            </div>
            <div class="search-overlay-form">
                <form>
                    <input type="text" class="input-search" placeholder="Search here...">
                    <button type="submit"><i class='bx bx-search-alt'></i></button>
                </form>
            </div>
        </div>
    </div>
</div>


<!-- Modal -->
<ng-template #popupname let-modal>
    <div class="modal-header" style="text-align: center;">
        <h5 style="text-align: center;" class="modal-title mt-0"> Login </h5>
        <button type="button" class="btn-close" (click)="modalDismiss()" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <app-login-page></app-login-page>

    </div>
</ng-template>